/* Spanish catalog mirroring locale-invoice-detail-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'inv.detail.completion': 'Finalización',
  'inv.detail.completed': 'Finalizado',
  'inv.detail.notCompleted': 'No finalizado',
  'inv.detail.paymentStatus': 'Estado del pago',
  'inv.detail.paid': 'Pagado',
  'inv.detail.remaining': 'Restante',
  'inv.detail.registeredPayments': 'Pagos registrados',
  'inv.detail.registerPayment': 'Registrar pago',
  'inv.detail.settlementStatus': 'Liquidación',
  'inv.detail.creditOffset': 'Compensada',
  'inv.detail.creditRefunded': 'Reembolsada',
  'inv.detail.creditOpen': 'Sin reembolsar',
  'inv.detail.offsetAgainst': 'Compensada con {document}',
  'inv.detail.offsetAgainstInvoice': 'Compensada con la factura',
  'inv.detail.refunded': 'Reembolsado',
  'inv.detail.toCredit': 'Pendiente de abonar al cliente',
  'inv.detail.registeredRefunds': 'Reembolsos registrados',
  'inv.detail.registerRefund': 'Registrar reembolso',
  'inv.detail.amountTitle': 'Importe',
  'inv.detail.amountHelp': 'El neto, el IVA y el total se calculan a partir de las líneas de factura guardadas.',
  'inv.detail.net': 'Neto',
  'inv.detail.totalAmount': 'Importe total',
  'inv.detail.history': 'Historial',
  'inv.detail.action': 'Acción',
  'inv.detail.loadingDoc': 'Cargando documento...',
  'inv.detail.openedFromLink': 'Documento abierto desde un enlace',
  'inv.act.open': 'Abrir',
  'inv.act.openHelp': 'Abre el borrador en Nueva venta para editarlo y enviarlo.',
  'inv.act.send': 'Enviar',
  'inv.act.sendAgain': 'Enviar de nuevo',
  'inv.act.sendCreditNote': 'Enviar nota de crédito',
  'inv.act.sendHelp': 'Envía el documento al cliente por correo electrónico a través del backend.',
  'inv.act.markDelivered': 'Marcar como entregado',
  'inv.act.markDeliveredHelp': 'Úsalo cuando el documento se haya entregado al cliente fuera de Plumme.',
  'inv.act.view.invoice': 'Ver factura',
  'inv.act.view.quote': 'Ver presupuesto',
  'inv.act.view.orderConfirmation': 'Ver confirmación de pedido',
  'inv.act.view.creditNote': 'Ver nota de crédito',
  'inv.act.viewHelp': 'Previsualiza el documento tal como lo ve el cliente.',
  'inv.act.copyLink': 'Copiar enlace',
  'inv.act.copyLinkHelp': 'Copia un enlace para compartir el documento.',
  'inv.act.download': 'Descargar',
  'inv.act.downloadHelp': 'Descarga el documento en PDF.',
  'inv.act.packingSlip': 'Crear albarán',
  'inv.act.packingSlipHelp': 'Crea y descarga un albarán de las mercancías de esta factura.',
  'inv.act.copy': 'Duplicar',
  'inv.toast.copyOpened': 'La copia está abierta: guárdala como borrador o créala',
  'inv.act.share': 'Compartir',
  'inv.act.shareHelp': 'Copia un enlace para compartir, descarga el PDF o crea un albarán.',
  'inv.share.title': 'Compartir el documento',
  'inv.act.convertOffer': 'Crear',
  'inv.act.convertOfferHelp': 'Crea una factura o una confirmación de pedido como borrador, con el cliente y las líneas del presupuesto.',
  'inv.convert.title': 'Crear a partir del presupuesto',
  'inv.convert.invoice': 'Factura',
  'inv.convert.invoiceHelp': 'Condiciones de pago habituales. Se contabiliza al crearla.',
  'inv.convert.order': 'Confirmación de pedido',
  'inv.convert.orderHelp': 'Confirma el acuerdo sin facturar. Se puede facturar más tarde.',
  'inv.act.markAccepted': 'Marcar como aceptado',
  'inv.act.markAcceptedHelp': 'Úsalo cuando el cliente haya aceptado el presupuesto por teléfono, en una reunión o por correo electrónico. La aceptación que el cliente hace en el enlace del presupuesto se registra automáticamente.',
  'inv.act.undoAccepted': 'Quitar aceptación',
  'inv.act.undoAcceptedHelp': 'Deshace una aceptación registrada aquí en la aplicación. Una aceptación hecha por el propio cliente no se puede quitar.',
  'inv.act.copyHelp': 'Crea una factura nueva con el mismo contenido que esta.',
  'inv.act.credit': 'Emitir nota de crédito',
  'inv.act.creditHelp': 'Crea una nota de crédito que compensa esta factura.',
  'inv.act.delete': 'Eliminar',
  'inv.act.deleteHelp': 'Elimina este borrador. Esta acción no se puede deshacer.',
  'inv.err.actionFailed': 'No se pudo completar la acción.',
  'inv.err.openDoc': 'No se pudo abrir el documento.',
  'inv.err.previewPacking': 'No se pudo previsualizar el albarán.',
  'inv.err.settleNotConnected': 'Saldar sin pago no está conectado al backend.',
  'inv.err.settleFailed': 'No se pudo saldar sin pago.',
  'inv.err.needEmail': 'Introduce primero el correo electrónico del destinatario.',
  'inv.err.emailCharset': 'Las direcciones de correo electrónico no pueden contener æ, ø, å ni otros caracteres especiales.',
  'inv.err.invalidEmail': 'No parece una dirección de correo electrónico válida.',
  'inv.err.acceptNotConnected': 'La aceptación no está conectada al backend.',
  'inv.err.acceptFailed': 'No se pudo actualizar la aceptación.',
  'inv.err.convertNotConnected': 'La conversión no está conectada al backend.',
  'inv.err.convertOpenFailed': 'El borrador se creó, pero no se pudo abrir.',
  'inv.err.convertFailed': 'No se pudo crear el documento a partir del presupuesto.',
  'inv.err.copyOpenFailed': 'La copia se creó, pero no se pudo abrir.',
  'inv.err.deleteNotConnected': 'La eliminación no está conectada al backend.',
  'inv.err.deleteFailed': 'No se pudo eliminar el borrador.',
  'inv.toast.onlyDrafts': 'Aquí solo se pueden eliminar borradores',
  'inv.toast.offerAccepted': 'El presupuesto se ha marcado como aceptado',
  'inv.toast.offerAcceptanceRemoved': 'Se ha quitado la aceptación',
  'inv.toast.invoiceDraftFromOffer': 'La factura está abierta: guárdala como borrador o créala',
  'inv.toast.orderDraftFromOffer': 'La confirmación de pedido está abierta: guárdala como borrador o créala',
  'inv.toast.draftDeleted': 'Borrador eliminado',
  'inv.pay.settleWithout': 'Saldada sin pago',
  'inv.pay.saveChange': 'Guardar cambio',
  'inv.pay.paidDate': 'Fecha de pago',
  'inv.pay.datePh': 'dd.mm.aaaa',
  'inv.pay.registerPaymentTitle': 'Registrar pago',
  'inv.pay.editPaymentTitle': 'Editar pago',
  'inv.pay.registerRefundTitle': 'Registrar reembolso',
  'inv.pay.editRefundTitle': 'Editar reembolso',
  'inv.pay.paidFrom': 'Pagado desde',
  'inv.pay.refundDate': 'Fecha del reembolso',
  'inv.pay.refundAmount': 'Importe reembolsado',
  'inv.pay.remainingNote': 'Pendiente en la factura: {amount}. Puedes registrar un pago parcial.',
  'inv.pay.refundNote': 'Se le deben {amount} al cliente por esta nota de crédito. Puedes registrar un reembolso parcial.',
  'inv.pay.refundHelp': 'La nota de crédito anula la venta en cualquier caso. Registra un reembolso solo cuando el cliente recupere realmente el dinero.',
  'inv.pay.fee': 'Comisión bancaria y de tarjeta',
  'inv.pay.feeAccount': 'Cuenta de comisiones',
  'inv.pay.bankAmountIn': 'Importe realmente recibido en el banco: {amount}',
  'inv.pay.bankAmountOut': 'Importe realmente pagado desde el banco: {amount}',
  'inv.detail.offsetCustomerCredit': 'Compensar crédito del cliente',
  'inv.detail.customerCreditOffset': 'Crédito del cliente compensado',
  'inv.detail.customerCreditAllocated': 'Compensada con otra factura',
  'inv.detail.relatedRefund': 'Reembolsada mediante la nota de crédito relacionada',
  'inv.toast.customerCreditOffset': 'El crédito del cliente se ha compensado con la factura',
  'inv.err.noCustomerCredit': 'No se encontró ninguna nota de crédito de cliente disponible.',
  'inv.err.customerCreditOffsetFailed': 'No se pudo compensar el crédito del cliente.',
  'cust.ledger.creditOffset': 'Crédito del cliente compensado',
  'inv.toast.paymentRegistered': 'Pago registrado',
  'inv.toast.paymentUpdated': 'Pago actualizado',
  'inv.toast.refundRegistered': 'Reembolso registrado',
  'inv.toast.refundUpdated': 'Reembolso actualizado',
  'inv.err.paymentFailed': 'No se pudo registrar el pago.',
  'inv.err.paymentUpdateFailed': 'No se pudo actualizar el pago.',
  'inv.err.refundFailed': 'No se pudo registrar el reembolso.',
  'inv.err.refundUpdateFailed': 'No se pudo actualizar el reembolso.',
  'inv.del.confirm': 'Sí, eliminar el borrador',
  'inv.del.body': '¿Seguro que quieres eliminar este borrador de {customer}? Esta acción no se puede deshacer.',
  'inv.send.body': '{document} por {amount} se enviará a {customer} como PDF por correo electrónico.',
  'inv.send.resendNote': ' Se trata de un reenvío de un documento que ya se ha enviado.',
  'inv.credit.continue': 'Continuar a la nota de crédito',
  'inv.credit.intro': 'Una nota de crédito compensa la factura de {customer}. Elige si quieres abonar la factura completa o solo una parte.',
  'inv.credit.full': 'Abono total',
  'inv.credit.partial': 'Abono parcial',
  'inv.credit.line': 'Línea',
  'inv.credit.count': 'Cantidad',
  'inv.credit.credited': 'A abonar',
  'inv.credit.total': 'Importe de la nota de crédito',
  'inv.credit.breakdown': 'Neto {net} · IVA {vat}',
  'inv.credit.partialSuffix': ' · abono parcial',
  'inv.delivery.rowFailed': 'No entregado',
  'inv.delivery.bannerTitle': '{n} documentos no llegaron al destinatario',
  'inv.delivery.bannerBody': 'El correo electrónico fue rechazado o devuelto: {documents}. Abre el documento, corrige la dirección de correo del cliente y vuelve a enviarlo.',
  'inv.credit.rest': 'Abonar el resto',
  'inv.credit.alreadyCredited': 'Ya abonado: {amount}. Solo se puede abonar el importe restante.',
  'inv.credit.closedLines': '{n} líneas están totalmente abonadas y no se muestran.',
  'inv.credit.lineAlready': 'abonado {amount}',
  'inv.credit.hasPayments': 'Esta factura tiene pagos registrados. La nota de crédito compensa el importe abierto; cualquier reembolso se registra por separado.',
  'inv.credit.date': 'Fecha de la nota de crédito',
  'inv.credit.dateHint': 'La fecha determina el periodo contable y de IVA del abono.',
  'inv.credit.dateBeforeInvoice': 'La fecha de la nota de cr?dito no puede ser anterior a la fecha de la factura.',
  'inv.credit.invalidDate': 'Elige una fecha válida para la nota de crédito.',
  'inv.credit.paidConfirmTitle': 'La factura está pagada',
  'inv.credit.paidConfirmBody': 'Esta factura tiene pagos registrados por {amount}. La nota de crédito anula la venta, pero cualquier reembolso se registra por separado. ¿Quieres continuar?',
  'inv.credit.paidConfirmContinue': 'Sí, continuar con el abono',
  'inv.bulk.creditDateHint': 'Se usa la misma fecha para todas las notas de crédito. Determina su periodo contable y de IVA.',
  'inv.bulk.creditDateBeforeInvoices': 'La fecha no puede ser anterior a la fecha de factura m?s reciente de la selecci?n.',
  'inv.bulk.creditPaidConfirmBody': '{n} de las facturas seleccionadas tienen pagos registrados. Las notas de crédito anulan las ventas, pero cualquier reembolso se registra por separado. ¿Quieres continuar?',
  'inv.history.creditPartial': 'Abono parcial de {amount} · nota de crédito {document}',
  'inv.history.creditFull': 'Abono de {amount} · nota de crédito {document}',
  'inv.history.creditDraft': 'Nota de crédito {document} creada como borrador · {amount}',
  'inv.history.creditNoNumber': 'sin número',
  'inv.toast.creditOpened': 'La nota de crédito de {document} está abierta: indica el motivo y créala',
  'inv.toast.partialCreditOpened': 'La nota de crédito parcial de {document} está abierta: indica el motivo y créala',
  'inv.bulk.selectAll': 'Seleccionar todo lo mostrado',
  'inv.bulk.selectRow': 'Seleccionar documento. Mayús+clic selecciona el rango.',
  'inv.bulk.selectDocument': 'Seleccionar documento',
  'inv.bulk.selectDocuments': 'Seleccionar documentos',
  'inv.bulk.selectedCount': '{n} seleccionados',
  'inv.bulk.shownCount': '{n} mostrados en la lista',
  'inv.bulk.reset': 'Borrar',
  'inv.bulk.deliver': 'Marcar como entregado',
  'inv.bulk.resend': 'Enviar de nuevo',
  'inv.bulk.reminder': 'Reclamación',
  'inv.bulk.credit': 'Emitir nota de crédito',
  'inv.bulk.issue': 'Crear y enviar',
  'inv.bulk.delete': 'Eliminar',
  'inv.bulk.processing': 'Procesando ...',
  'inv.bulk.document': 'Documento',
  'inv.bulk.amount': 'Importe',
  'inv.bulk.more': '+ {n} más',
  'inv.bulk.noEmail': 'sin correo electrónico',
  'inv.bulk.newDueDate': 'nuevo vencimiento {date}',
  'inv.bulk.reminderType': 'Tipo',
  'inv.bulk.reminderNotice': 'Recordatorio de pago',
  'inv.bulk.reminderDunning': 'Reclamación de pago',
  'inv.bulk.reminderDueDays': 'Días hasta el nuevo vencimiento',
  'inv.bulk.reminderFee': 'Gastos de reclamación',
  'inv.bulk.reminderFeeLocked': 'Solo se pueden añadir gastos en una reclamación de pago.',
  'inv.bulk.delivery': 'Enviar como',
  'inv.bulk.deliveryPdf': 'PDF adjunto',
  'inv.bulk.deliveryLink': 'Enlace',
  'inv.bulk.comment': 'Mensaje para el cliente',
  'inv.bulk.commentHint': 'Aparece en el correo junto al resumen de importes. La factura en sí no se modifica.',
  'inv.bulk.commentPh': 'Por ejemplo: Vemos que esta factura sigue pendiente de pago. Si algo no está claro, ponte en contacto con nosotros.',
  'inv.comment.label': 'Mensaje para el cliente',
  'inv.comment.hint': 'Texto opcional que acompaña a este envío.',
  'inv.comment.placeholder': 'Escribe un mensaje ...',
  'inv.comment.useSaved': 'Usar un mensaje guardado',
  'inv.comment.save': 'Guardar mensaje',
  'inv.comment.update': 'Actualizar mensaje',
  'inv.comment.saveTitle': 'Guardar mensaje',
  'inv.comment.updateTitle': 'Actualizar mensaje',
  'inv.comment.saveAsNew': 'Guardar como nuevo',
  'inv.comment.savedTitle': 'Mensajes guardados',
  'inv.comment.name': 'Nombre del mensaje',
  'inv.comment.namePh': 'Por ejemplo: Recordatorio amable',
  'inv.comment.nameHint': 'El nombre te permite volver a encontrar el mensaje en la lista.',
  'inv.comment.needName': 'Ponle primero un nombre al mensaje',
  'inv.comment.empty': 'Aún no tienes mensajes guardados.',
  'inv.comment.use': 'Usar',
  'inv.comment.saved': 'Mensaje guardado',
  'inv.comment.updated': 'Mensaje actualizado',
  'inv.comment.deleted': 'Mensaje eliminado',
  'inv.comment.saveFailed': 'No se pudo guardar el mensaje.',
  'inv.comment.deleteFailed': 'No se pudo eliminar el mensaje.',
  'inv.comment.notConnected': 'Los mensajes no están conectados al backend.',
  'inv.bulk.mode': 'Qué debe ocurrir',
  'inv.bulk.mode.draft': 'Guardar como borradores',
  'inv.bulk.mode.send': 'Crear y enviar',
  'inv.bulk.mode.create': 'Solo crear',
  'inv.bulk.mode.hint.credit': 'Las notas de crédito van a la pestaña de borradores. No se contabiliza ni se envía nada hasta que las crees.',
  'inv.bulk.mode.hint.creditSend': 'Las notas de crédito se contabilizan y se envían por correo electrónico a los clientes de inmediato. Esta acción no se puede deshacer.',
  'inv.bulk.mode.hint.issueSend': 'Los borradores se contabilizan con un número de documento y se envían por correo electrónico a los clientes.',
  'inv.bulk.mode.hint.issue': 'Los borradores se contabilizan con un número de documento, pero no se envía ningún correo electrónico.',
  'inv.bulk.creditReasonOptional': 'Opcional mientras la nota de crédito sea un borrador. El motivo debe estar indicado antes de poder contabilizarla.',
  'inv.bulk.creditReasonRequired': 'Obligatorio. El motivo aparece en la nota de crédito y documenta por qué se anuló la venta.',
  'inv.bulk.title.deliver': 'Marcar los documentos seleccionados como entregados',
  'inv.bulk.title.send': 'Enviar de nuevo los documentos seleccionados',
  'inv.bulk.title.reminder': 'Enviar una reclamación o un recordatorio de pago',
  'inv.bulk.title.credit': 'Emitir nota de crédito de las facturas seleccionadas',
  'inv.bulk.title.issue': 'Crear los borradores seleccionados',
  'inv.bulk.title.delete': 'Eliminar los borradores seleccionados',
  'inv.bulk.confirm.deliver': 'Marcar como entregado',
  'inv.bulk.confirm.send': 'Enviar de nuevo',
  'inv.bulk.confirm.reminder': 'Enviar seguimiento',
  'inv.bulk.confirm.credit': 'Crear notas de crédito',
  'inv.bulk.confirm.creditSend': 'Crear y enviar notas de crédito',
  'inv.bulk.confirm.issue': 'Crear los documentos',
  'inv.bulk.confirm.issueSend': 'Crear y enviar',
  'inv.bulk.confirm.delete': 'Sí, eliminar los borradores',
  'inv.bulk.body.deliver': 'Documentos que se marcarán como entregados fuera de Plumme: {n}. No se envía ningún correo electrónico, y la contabilidad y el pago no cambian.',
  'inv.bulk.body.send': '{n} documentos se enviarán a la dirección de correo electrónico guardada en el cliente.',
  'inv.bulk.body.reminder': 'Se hace seguimiento de {n} facturas vencidas o pendientes de pago. La factura original no se vuelve a contabilizar.',
  'inv.bulk.body.credit': 'Se abonan {n} facturas por el importe restante, con una nota de crédito por factura. Las líneas ya abonadas no se incluyen de nuevo.',
  'inv.bulk.body.creditSend': 'Se abonan {n} facturas por el importe restante. Las notas de crédito se crean, se contabilizan y se envían al cliente de inmediato, sin pasar por borradores.',
  'inv.bulk.body.issue': '{n} borradores se crean y se contabilizan, y reciben un número de documento.',
  'inv.bulk.body.issueSend': '{n} borradores se crean, se contabilizan y se envían al cliente por correo electrónico.',
  'inv.bulk.body.delete': '{n} borradores se eliminarán. Los borradores no están contabilizados, pero la eliminación no se puede deshacer.',
  'inv.bulk.skip.deliver': 'Filas seleccionadas que son borradores, ya entregadas o enviadas, y que se omitirán: {n}.',
  'inv.bulk.skip.send': '{n} documentos seleccionados no tienen correo electrónico y se omiten.',
  'inv.bulk.skip.reminder': '{n} filas seleccionadas no admiten reclamación aquí o no tienen correo electrónico.',
  'inv.bulk.skip.credit': '{n} filas seleccionadas no se pueden abonar desde aquí.',
  'inv.bulk.skip.issue': '{n} borradores seleccionados no tienen cliente o líneas y no se pueden crear desde aquí.',
  'inv.bulk.skip.noEmail': '{n} de los documentos no tienen dirección de correo electrónico. Se crean y se contabilizan, pero no se envían.',
  'inv.bulk.skip.delete': '{n} filas seleccionadas no son borradores y no se eliminarán.',
  'inv.bulk.toast.delivered': 'Documentos marcados como entregados: {n}',
  'inv.bulk.toast.sent': '{n} documentos enviados',
  'inv.bulk.toast.reminded': '{n} recordatorios de pago enviados',
  'inv.bulk.toast.dunned': '{n} reclamaciones de pago enviadas',
  'inv.bulk.toast.credited': '{n} notas de crédito creadas como borradores',
  'inv.bulk.toast.creditedSent': '{n} notas de crédito creadas y enviadas',
  'inv.bulk.toast.issued': '{n} documentos creados',
  'inv.bulk.toast.issuedSent': '{n} documentos creados y enviados',
  'inv.bulk.toast.deleted': '{n} borradores eliminados',
  'inv.bulk.toast.notSentSuffix': ', {n} creados sin correo electrónico',
  'inv.bulk.toast.failedSuffix': ', {n} fallidos',
  'inv.bulk.err.failed': 'No se pudo completar la acción en bloque.',
  'inv.bulk.err.deliverNotConnected': 'Marcar como entregado no está conectado al backend.',
  'inv.bulk.err.sendNotConnected': 'El envío no está conectado al backend.',
  'inv.bulk.err.creditNotConnected': 'La emisión de notas de crédito no está conectada al backend.',
  'inv.bulk.err.issueNotConnected': 'La creación de borradores no está conectada al backend.',
  'inv.packing.preview': 'Vista previa',
  'inv.packing.download': 'Descargar albarán',
  'inv.packing.invoiceDate': 'Fecha de factura',
  'inv.pay.account.1920': 'Cuenta corriente - 1920',
  'inv.pay.account.2063': 'Privado - 2063',
  'inv.pay.account.1900': 'Efectivo - 1900',
  'inv.report.customer': 'Cliente',
  'inv.report.product': 'Producto',
  'inv.report.salesCount': 'Ventas',
  'inv.report.count': 'Cantidad',
  'inv.report.exVat': 'Sin IVA',
  'inv.report.share': 'Porcentaje del total',
  'inv.report.noSales': 'No hay ventas en el periodo.',
  'inv.report.noProducts': 'No se vendieron productos en el periodo.',
  'inv.report.openCustomer': 'Abrir {name} en Clientes',
  'inv.report.totalCustomers': '({n} clientes)',
  'inv.report.totalCustomer': '({n} cliente)',
  'inv.report.totalProducts': '({n} productos)',
  'inv.report.totalProduct': '({n} producto)',
  'inv.report.total': 'Total',
  'inv.report.tile.sales': 'Ventas',
  'inv.report.tile.activeCustomers': 'Clientes activos',
  'inv.report.tile.newCustomers': 'Clientes nuevos',
  'inv.report.tile.totalCustomers': 'Total de clientes',
  'inv.report.tile.customerRevenue': 'Ingresos por clientes',
  'inv.report.tile.totalRevenue': 'Ingresos totales',
  'inv.report.tile.soldProducts': 'Productos vendidos',
  'inv.report.tile.productTypes': 'Tipos de producto',
  'inv.report.tile.productRevenue': 'Ingresos por productos',
  'inv.report.unknownCustomer': 'Cliente desconocido',
  'inv.report.unspecifiedSale': 'Venta sin especificar',
  'inv.report.customerSummaryOne': 'Se registraron {sales} ventas a {customers} cliente durante el periodo. Las ventas a clientes ascendieron a {amount}.',
  'inv.report.customerSummaryMany': 'Se registraron {sales} ventas a {customers} clientes durante el periodo. Las ventas a clientes ascendieron a {amount}.',
  'inv.report.productSummaryOne': 'Se vendieron {count} productos/líneas de {types} tipo de producto durante el periodo, por un total de {amount}.',
  'inv.report.productSummaryMany': 'Se vendieron {count} productos/líneas de {types} tipos de producto durante el periodo, por un total de {amount}.',
  'inv.fallback.noCustomer': 'Sin cliente',
  'inv.fallback.line': 'Línea {n}',
  'inv.credit.fallbackDescription': 'Venta según {document}',
  'inv.credit.dialogTitle': 'Emitir nota de crédito de la factura {number}',
  'inv.detail.validUntil': 'Válido hasta',
  'inv.detail.dueDate': 'Fecha de vencimiento',
  'inv.detail.partiallyPaid': 'Pagada parcialmente',
  'inv.detail.unpaid': 'Pendiente de pago',
  'inv.detail.acceptedManual': 'Aceptado el {date} · registrado en la aplicación',
  'inv.detail.acceptedCustomer': 'Aceptado el {date} · por el cliente',
  'inv.detail.orderSentAt': 'Confirmación de pedido enviada el {date}',
  'inv.detail.paymentFeeBank': 'Comisión {fee} · Banco {bank}',
  'inv.detail.deliveryFailureHelp': 'El documento está guardado, pero el destinatario no lo recibió. Corrige la dirección de correo del cliente y vuelve a enviarlo.',
  'inv.detail.timelineHelp': 'Cronología elaborada a partir del estado guardado del documento y de los pagos.',
  'inv.history.offerAcceptedManual': 'Presupuesto marcado como aceptado (registrado en la aplicación)',
  'inv.history.offerAcceptedCustomer': 'Presupuesto aceptado por el cliente',
  'inv.history.orderSent': 'Confirmación de pedido enviada',
  'inv.history.documentSentTo': '{document} enviado a {recipient}',
  'inv.history.deliveredExternally': 'Entregado fuera de Plumme',
  'inv.history.documentCreated': 'Documento creado',
  'inv.packing.intro': 'Define la fecha de envío. De forma predeterminada se selecciona hoy.',
  'inv.packing.shippingDate': 'Fecha de envío',
  'inv.packing.contents': 'El albarán muestra las descripciones y cantidades de las líneas de la factura. No se muestran los precios, el IVA ni la información de pago.',
  'inv.packing.title': 'Albarán {number}',
  'inv.err.pdfPreviewNotConnected': 'La vista previa en PDF no está conectada al backend.',
  'inv.err.packingNotConnected': 'Los albaranes no están conectados al backend.',
  'inv.err.packingDownloadFailed': 'No se pudo descargar el albarán.',
  'inv.err.paymentNotConnected': 'Los pagos no están conectados al backend.',
  'inv.err.paymentEditNotConnected': 'La edición de pagos no está conectada al backend.',
  'inv.err.sendNotConnected': 'El envío no está conectado al backend.',
  'inv.err.sendFailed': 'No se pudo enviar el documento.',
  'inv.err.deliverNotConnected': 'Marcar como entregado no está conectado al backend.',
  'inv.err.deliverFailed': 'No se pudo marcar el documento como entregado.',
  'inv.err.linkNotConnected': 'Los enlaces de factura no están conectados al backend.',
  'inv.err.linkFailed': 'No se pudo obtener el enlace de la factura.',
  'inv.err.downloadNotConnected': 'La descarga en PDF no está conectada al backend.',
  'inv.err.downloadFailed': 'No se pudo descargar el documento.',
  'inv.err.copyNotConnected': 'La copia no está conectada al backend.',
  'inv.err.copyFailed': 'No se pudo copiar el documento.',
  'inv.err.archiveNotConnected': 'El archivado no está conectado al backend.',
  'inv.err.archiveFailed': 'No se pudo actualizar el estado de archivado.',
  'inv.err.creditNotConnected': 'La emisión de notas de crédito no está conectada al backend.',
  'inv.err.creditFailed': 'No se pudo crear la nota de crédito.',
  'inv.toast.packingDownloading': 'Descargando el albarán',
  'inv.toast.settledWithoutPayment': 'La factura se saldó sin pago',
  'inv.toast.sendingBackground': '{document} se está enviando en segundo plano',
  'inv.toast.documentSent': '{document} enviado',
  'inv.toast.deliveredExternally': 'El documento se ha marcado como entregado',
  'inv.toast.readyNoEmail': 'El documento está listo, pero no se envió ningún correo electrónico.',
  'inv.toast.linkCopied': 'Enlace a {number} copiado',
  'inv.toast.documentDownloading': 'Descargando el documento',
  'inv.toast.archiveRestored': 'Restaurado del archivo',
  'inv.toast.archived': 'Archivado',
  'inv.toast.creditCreated': '{document} creado para {number}',
  'inv.act.unarchive': 'Restaurar del archivo',
  'inv.act.archive': 'Archivar',
  'inv.act.archiveHelp': 'Mueve el presupuesto o la confirmación de pedido al archivo, o restáuralo.',
  'inv.convert.alreadyTitle': 'El presupuesto ya se ha convertido en:',
  'inv.convert.duplicateWarning': 'Si creas otro documento, asegúrate de que no se factura dos veces al cliente por el mismo trabajo.',
  'inv.convert.footerHelp': 'Ambos se crean como borradores con el cliente y las líneas del presupuesto, y se abren en el flujo de ventas.',
  'inv.send.title': 'Enviar {document} {number}',
  'inv.deliver.title': 'Marcar como entregado',
  'inv.deliver.body': 'Úsalo cuando el documento ya se haya entregado al cliente por otro medio. Plumme no envía ningún correo electrónico. La contabilización, el IVA y el estado del pago no cambian, pero los avisos sobre un documento sin enviar se detienen.',
  'inv.delivery.external': 'Entregado fuera de Plumme',
  'inv.more': 'Más',
  'inv.err.offerAlreadyConverted': 'El presupuesto ya se ha convertido en este tipo de documento.',
  'sale.totalDiscount': 'Descuento global',
  'sale.totalDiscountHelp': 'Se reparte proporcionalmente entre todas las líneas de producto y se guarda con un reparto trazable.',
  'sale.det.currency': 'Moneda del documento',
  'sale.det.exchangeRate': 'Tipo de cambio a {currency}',
  'sale.det.exchangeRateDate': 'Fecha del tipo de cambio',
  'sale.det.exchangeRateSource': 'Fuente del tipo de cambio',
  'sale.det.exchangeRateSourcePh': 'Por ejemplo Norges Bank o un tipo de cambio acordado',
  'sale.create.needCurrencyEvidence': 'Indica un tipo de cambio positivo, su fecha y su fuente antes de crear la factura.',
  'sale.preview.accountingAmount': 'Importe contable: {amount} {currency} · tipo de cambio {rate}',
  'sale.preview.vatAccountingAmount': 'IVA en {currency}: {amount}',
});
